import React, { useState } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { useParams } from 'react-router-dom';

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';

import logger from '../../utils/logger';
import TabPanel from '../TabPanel';
import { logReactErrBoundaryError } from '../../utils';
import FallbackOnError from '../FallbackOnError';
import CodeGroupings from '../../views/CodeGroupings';
import BulkUpload from '../../views/BulkUpload';

function Codes() {
  const [tab, setTab] = useState(0);
  const param = useParams();
  const { client } = param;

  const handleChange = (event, newValue) => {
    setTab(newValue);
  };

  return (
    <ErrorBoundary
      FallbackComponent={FallbackOnError}
      onError={logReactErrBoundaryError}
      onReset={(details) => {
        logger.info('details', details);
        // Reset the state of your app so the error doesn't happen again
      }}
    >
      <div>
        <header className="App-header">
          <h2>Codes Management</h2>
        </header>
        <Box sx={{ width: '100%' }}>
          <>
            {' '}
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <Tabs value={tab} onChange={handleChange}>
                <Tab label="Group Codes" />
                <Tab label="Bulk Upload" />
              </Tabs>
            </Box>
            <>
              <TabPanel label="Group Codes" value={tab} index={0}>
                <CodeGroupings client={client} />
              </TabPanel>
              <TabPanel label="Bulk Upload" value={tab} index={1}>
                <BulkUpload client={client} />
              </TabPanel>
            </>
          </>
        </Box>
      </div>
    </ErrorBoundary>
  );
}

export default Codes;
